// Maps the rule catalog's icon NAME strings to lucide-react
// components (Automations v2 — PR3). The shared catalog stays
// React-free by referencing icons by name; this is the one place that
// resolves a name to a component.

import {
  AlarmClock,
  AlertTriangle,
  Banknote,
  Bell,
  BellRing,
  Bold,
  Building2,
  Cake,
  CalendarCheck,
  CalendarCheck2,
  CalendarClock,
  CalendarHeart,
  CalendarOff,
  CalendarRange,
  CalendarSync,
  CalendarX,
  CheckCircle2,
  CheckSquare,
  ClipboardCheck,
  ChevronDown,
  ChevronLeft,
  Clock,
  CopyX,
  DoorOpen,
  DollarSign,
  Eye,
  FileClock,
  FileEdit,
  FileSignature,
  FileText,
  Flag,
  FlaskConical,
  GitBranch,
  Home,
  Italic,
  Layers,
  Link2,
  Link2Off,
  List,
  ListOrdered,
  type LucideIcon,
  Mail,
  MailCheck,
  MailX,
  Megaphone,
  MoveRight,
  MousePointerClick,
  Pencil,
  PencilLine,
  Phone,
  PhoneOff,
  Package,
  PartyPopper,
  Play,
  Plus,
  PlusCircle,
  RemoveFormatting,
  Search,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldPlus,
  SlidersHorizontal,
  Sparkles,
  Star,
  StickyNote,
  Tag,
  Target,
  TimerOff,
  Landmark,
  TrendingDown,
  Underline,
  Video,
  User,
  UserCheck,
  UserPlus,
  Users,
  UserX,
  XCircle,
  Zap,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  AlarmClock,
  AlertTriangle,
  Banknote,
  Bell,
  BellRing,
  Bold,
  Building2,
  Cake,
  CalendarCheck,
  CalendarCheck2,
  CalendarOff,
  CalendarSync,
  CalendarX,
  CalendarClock,
  CalendarHeart,
  CalendarRange,
  CheckCircle2,
  CheckSquare,
  ClipboardCheck,
  ChevronDown,
  ChevronLeft,
  Clock,
  CopyX,
  DoorOpen,
  DollarSign,
  Eye,
  FileClock,
  FileEdit,
  FileSignature,
  FileText,
  Flag,
  FlaskConical,
  GitBranch,
  Home,
  Italic,
  Layers,
  Link2,
  Link2Off,
  List,
  ListOrdered,
  Mail,
  MailCheck,
  MailX,
  Megaphone,
  MoveRight,
  MousePointerClick,
  Pencil,
  PencilLine,
  Phone,
  PhoneOff,
  Package,
  PartyPopper,
  Play,
  Plus,
  PlusCircle,
  RemoveFormatting,
  Search,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldPlus,
  SlidersHorizontal,
  Sparkles,
  Star,
  StickyNote,
  Tag,
  Target,
  TimerOff,
  Landmark,
  TrendingDown,
  Underline,
  Video,
  User,
  UserCheck,
  UserPlus,
  Users,
  UserX,
  XCircle,
  Zap,
};

export function CatalogIcon({
  name,
  size = 16,
  className,
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const Cmp = ICONS[name] ?? Zap;
  return <Cmp size={size} className={className} aria-hidden />;
}
